import { Outlet, useSearchParams } from "react-router-dom";

import { WindowCloser } from "../../components/embedded/form-builder/shared/window-closer";
import { builderWindowCloseParam } from "../../components/embedded/settings/paths";

const BuilderLayout = () => {
  const [searchParams] = useSearchParams();
  const showCloser = searchParams.get(builderWindowCloseParam) !== "false";

  return (
    <>
      {showCloser && (
        <div className="fixed top-[0.7rem] right-[0.5rem] z-1">
          <WindowCloser />
        </div>
      )}
      <Outlet />
    </>
  );
};

export { BuilderLayout };
